import request from '@/utils/infrastructure/communication/request';

export async function generateReportToken(id) {
  return request(`/report/generateToken/${id}`, {
    method: 'POST',
  });
}

export async function updateFavorite({ id, isFavorite }) {
  return isFavorite
    ? request.delete(`/report/favorites/${id}`, {})
    : request.post(`/report/favorites/${id}`, {});
}

export async function handleReportOperation(reportId, params) {
  return request(`/report/handleOperation/${reportId}`, {
    method: 'POST',
    data: params,
  });
}

export async function getReportTask(reportId, taskId) {
  return request(`/report/task/${reportId}/${taskId}`);
}
